exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".alert-dismissible .close{right:0;outline:none}", "", {"version":3,"sources":["/opt/snt/front-end-turnos/src/app/turnos/shared/alert/alert.component.scss"],"names":[],"mappings":"AAAA,0BACE,QAAQ,YACK,CACd","file":"alert.component.scss","sourcesContent":[".alert-dismissible .close {\r\n  right: 0;\r\n  outline: none;\r\n}\r\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/turnos/shared/alert/alert.component.scss
// module id = rbsW
// module chunks = 2